import React, { HTMLAttributes } from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import formatDate from '../../../../helpers/formatDate';
import useClasses from '../../../../hooks/useClasses';
import { CoreLink } from '../../../../components';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import { ImmutableDiaryNodeEntity } from '../..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableDiaryNodeEntity;
}

const NodeDiaryTeaser: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeDiary--Teaser');

  const langcode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = entity.getIn(['paths', langcode], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['field_diary_body', 0, 'processed'], entity.getIn(['field_encrypted_body', 0, 'processed'], entity.getIn(['body', 0, 'processed'], '')));
  const entryDate = entity.getIn(['field_diary_entry_date', 0, 'value'], '');

  return (
    <li className={joinClasses(buildClass(), className)}>
      <CoreLink to={path}>
        <h2 className={joinClasses(buildClass('title'), 'asH4', 'u-word-break')}>
          {title}
        </h2>

        <WysiwygField
          className={joinClasses(buildClass('body'), 'u-word-break')}
          property="schema:text"
          html={body}
        />

        <div className={buildClass('entryDate')}>
          {formatDate(entryDate, 'DD MMM YYYY')}
        </div>
      </CoreLink>
    </li>
  );
};

export default NodeDiaryTeaser;
